import React from 'react'
import { Box, Dialog, DialogContent, Typography } from '@mui/material'
import { RoundedButton } from 'common/Button/Button'
import Lottie from 'lottie-react'

import successLottie from '../../../../../assets/successLottie.json'

interface winbackSuccessDialogProps {
  showWinbackSuccessDialog: boolean
  handleDialogClose: (value: void) => void
  title: string
}
const winbackSuccessDialog = ({
  showWinbackSuccessDialog,
  handleDialogClose,
  title
}: winbackSuccessDialogProps) => {
  return (
    <>
      <Dialog
        open={showWinbackSuccessDialog}
        maxWidth='lg'
        onClose={() => {
          handleDialogClose()
        }}
      >
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}
          >
            <Box sx={{ m: '60px 150px 20px 150px' }}>
              <Lottie
                animationData={successLottie}
                loop
                style={{ width: '140px', height: '140px' }}
              />
            </Box>
            <Typography textAlign='center'>
              {title} successfully given!
            </Typography>
          </Box>
        </DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'center', m: '40px' }}>
          <RoundedButton
            variant='filled'
            onClick={() => {
              handleDialogClose()
            }}
          >
            Continue to dashboard
          </RoundedButton>
        </Box>
      </Dialog>
    </>
  )
}

export default winbackSuccessDialog
